import { ref, watch, onBeforeUnmount, readonly } from 'vue'

/**
 * 時刻計算の基準日時
 * intervalで自動更新される
 */
export function useBaseDate() {
  /**
   * 基準日時
   * @type {Ref.<Date>}
   */
  const baseDate = ref(new Date())
  /**
   * 更新インターバル(s)
   * @type {Ref.<Number>}
   */
  const interval = ref(10)
  /**
   * インターバルID(非リアクティブ)
   * @type {Number}
   */
  let intervalId

  /**
   * 自動更新開始
   * 既に開始されている場合は前のインターバル処理を破棄して新しく生成します
   */
  const startInterval = () => {
    if (intervalId) {
      stopInterval()
    }
    intervalId = setInterval(() => {
      baseDate.value = new Date()
    }, interval.value * 1000)
  }

  /**
   * 自動更新停止
   */
  const stopInterval = () => {
    if (!intervalId) return
    clearInterval(intervalId)
    intervalId = undefined
  }

  // 間隔変更時にインターバル処理を作り直す
  watch(interval, startInterval)

  // 破棄前に更新を停止する
  onBeforeUnmount(() => {
    if (intervalId) {
      stopInterval()
    }
  })

  // created 相当処理
  startInterval()

  return { baseDate: readonly(baseDate), interval, startInterval, stopInterval }
}
